export default "__VITE_ASSET__BlIvW9IL__"